import { createFileRoute } from "@tanstack/react-router";
import { heritageTopicRoute } from "@/lib/seo/heritageTopicRoute";
import { getHeritageTopic } from "@/lib/seo/heritageTopics";

export const Route = createFileRoute("/heritage/slakthistoria-pa-film")(
  heritageTopicRoute(getHeritageTopic("slakthistoria-pa-film")!),
);
